import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SimpleGrid } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import ProgressLoader from '../../../../progressLoader';

import AssetViewer from '../../../../assets/assetViewer';


const ViewerDialogAssetContent = props => {

    const [assetId, setAssetId] = useState<number>()



    useEffect(() => {
        if (
            props.viewerStore.selectedAssetId! === undefined
        ) {
            setAssetId(undefined);

        } else {
            setAssetId(props.viewerStore.selectedAssetId!);

        }
    }, []);




    return (
        <>
            {props.viewerStore.isLoading ? (<ProgressLoader />) :
                (
                    assetId == undefined ?
                        (<><SimpleGrid columns={2} spacing={3}>
                            No Asset Found
                        </SimpleGrid></>)
                        : (<AssetViewer assetId={assetId} />))}
        </>
    );
}

ViewerDialogAssetContent.propTypes = {
    handleClose: PropTypes.any,
    userId: PropTypes.any,
    viewerStore: PropTypes.any,

}

export default observer(ViewerDialogAssetContent)